import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useUser } from "@/hooks/useUser";
import { Role } from "@/types";
import {
  ArrowRight,
  CheckCircle2,
  FileCheck2,
  FileText,
  GraduationCap,
  LayoutDashboard,
  Users,
  ShieldCheck,
  Stethoscope,
  Eye,
  UserCog,
  Building2,
  Globe2,
  Mic2,
} from "lucide-react";
import { Link, Navigate } from "react-router-dom";

export default function GlobalDashboardPage() {
  const { user, isPending } = useUser();

  const getCardContent = (jenis_user: Role) => {
    switch (jenis_user) {
      // --- LOKET ---
      case "loket_1":
      case "loket_2":
      case "loket_3":
      case "loket_4":
      case "loket_5":
        const noLoket = jenis_user.split("_")[1];
        return {
          title: `Loket ${noLoket} Daftar Kembali`,
          path: `/loket?no=${noLoket}`,
          icon: <Building2 className="w-6 h-6" />,
          description: `Akses layanan pendaftaran ulang di Loket ${noLoket}.`,
          color: "bg-blue-100 text-blue-600",
          darkColor: "dark:bg-blue-900/30 dark:text-blue-400",
        };
      case "loket_all":
        return {
          title: "Loket Daftar Kembali",
          path: "/loket?no=1",
          icon: <Building2 className="w-6 h-6" />,
          description: "Akses menu utama layanan loket pendaftaran.",
          color: "bg-blue-100 text-blue-600",
          darkColor: "dark:bg-blue-900/30 dark:text-blue-400",
        };

      // --- VERIFIKATOR ---
      case "verifikator_ukt":
      case "verifikator_ukt_all":
        return {
          title: "Verifikasi Berkas UKT",
          path: "/verifikator/dashboard",
          icon: <FileCheck2 className="w-6 h-6" />,
          description: "Validasi dokumen penentuan Uang Kuliah Tunggal.",
          color: "bg-emerald-100 text-emerald-600",
          darkColor: "dark:bg-emerald-900/30 dark:text-emerald-400",
        };
      case "verifikator_raport":
      case "verifikator_raport_all":
        return {
          title: "Verifikasi Nilai Rapor",
          // path: "/verifikator/raport/verifikasi-raport-peserta",
          path: "/verifikator/raport/verifikasi-nilai-raport-smbjm",
          icon: <FileText className="w-6 h-6" />,
          description: "Pemeriksaan nilai rapor peserta jalur prestasi.",
          color: "bg-orange-100 text-orange-600",
          darkColor: "dark:bg-orange-900/30 dark:text-orange-400",
        };
      case "verifikator_butawarna":
      case "verifikator_butawarna_all":
        return {
          title: "Verifikasi Buta Warna",
          path: "/verifikator/butawarna/verifikasi-peserta-butawarna",
          icon: <Eye className="w-6 h-6" />,
          description: "Input hasil tes buta warna peserta.",
          color: "bg-purple-100 text-purple-600",
          darkColor: "dark:bg-purple-900/30 dark:text-purple-400",
        };
      case "verifikator_sehat":
      case "verifikator_sehat_all":
        return {
          title: "Verifikasi Kesehatan",
          path: "/verifikator/surat-keterangan-sehat/verifikasi-peserta-surat-keterangan-sehat",
          icon: <Stethoscope className="w-6 h-6" />,
          description: "Validasi surat keterangan sehat peserta.",
          color: "bg-pink-100 text-pink-600",
          darkColor: "dark:bg-pink-900/30 dark:text-pink-400",
        };
      case "verifikator_skl":
      case "verifikator_skl_all":
        return {
          title: "Verifikasi SKL",
          path: "/verifikator/skl/verifikasi-skl-peserta",
          icon: <CheckCircle2 className="w-6 h-6" />,
          description: "Validasi Surat Keterangan Lulus.",
          color: "bg-cyan-100 text-cyan-600",
          darkColor: "dark:bg-cyan-900/30 dark:text-cyan-400",
        };
      case "verifikator_kepemimpinan":
      case "verifikator_kepemimpinan_all":
        return {
          title: "Verifikasi Kepemimpinan",
          path: "/verifikator/kepemimpinan/verifikasi-peserta-kepemimpinan-smbjm",
          icon: <Users className="w-6 h-6" />,
          description: "Pemeriksaan dan validasi berkas kepemimpinan.",
          color: "bg-fuchsia-100 text-fuchsia-600",
          darkColor: "dark:bg-fuchsia-900/30 dark:text-fuchsia-400",
        };
      case "verifikator_pasca":
        return {
          title: "Verifikator Pascasarjana",
          path: "/verifikator-pasca/penilaian",
          icon: <GraduationCap className="w-6 h-6" />,
          description: "Penilaian berkas calon mahasiswa S2/S3.",
          color: "bg-indigo-100 text-indigo-600",
          darkColor: "dark:bg-indigo-900/30 dark:text-indigo-400",
        };

      // --- ADMIN & MANAGEMENT ---
      case "superadmin":
        return {
          title: "Super Admin",
          path: "/admin/dashboard",
          icon: <ShieldCheck className="w-6 h-6" />,
          description: "Akses penuh pengaturan sistem dan pengguna.",
          color: "bg-slate-800 text-white",
          darkColor: "dark:bg-slate-700 dark:text-slate-100",
        };
      case "pimpinan":
        return {
          title: "Dashboard Pimpinan",
          path: "/pimpinan/dashboard",
          icon: <LayoutDashboard className="w-6 h-6" />,
          description: "Monitoring data dan statistik penerimaan.",
          color: "bg-amber-100 text-amber-700",
          darkColor: "dark:bg-amber-900/30 dark:text-amber-400",
        };
      case "akademik":
        return {
          title: "Operator Akademik",
          path: "/akademik/data-pendaftaran",
          icon: <Users className="w-6 h-6" />,
          description: "Manajemen data akademik pendaftar.",
          color: "bg-teal-100 text-teal-700",
          darkColor: "dark:bg-teal-900/30 dark:text-teal-400",
        };

      // --- OPERATOR KHUSUS ---
      case "operator_pasca":
        return {
          title: "Operator Pascasarjana",
          path: "/operator-pasca/dashboard",
          icon: <UserCog className="w-6 h-6" />,
          description: "Manajemen pendaftaran program pascasarjana.",
          color: "bg-violet-100 text-violet-700",
          darkColor: "dark:bg-violet-900/30 dark:text-violet-400",
        };
      case "operator_internasional":
        return {
          title: "Operator Internasional",
          path: "/operator-internasional/dashboard",
          icon: <Globe2 className="w-6 h-6" />,
          description: "Manajemen mahasiswa program internasional.",
          color: "bg-sky-100 text-sky-700",
          darkColor: "dark:bg-sky-900/30 dark:text-sky-400",
        };
      case "wawancara_talent":
        return {
          title: "Wawancara Talent",
          path: "/wawancara-talentscouting/data-pendaftaran",
          icon: <Mic2 className="w-6 h-6" />,
          description: "Penilaian sesi wawancara talentscouting.",
          color: "bg-rose-100 text-rose-700",
          darkColor: "dark:bg-rose-900/30 dark:text-rose-400",
        };
      case "panitia_smbjm":
        return {
          title: "Panitia SMBJM",
          path: "/panitia-smbjm/ruang-cbt-detail",
          icon: <Users className="w-6 h-6" />,
          description: "Manajemen ruang dan pelaksanaan CBT.",
          color: "bg-lime-100 text-lime-700",
          darkColor: "dark:bg-lime-900/30 dark:text-lime-400",
        };
      case "operator_studentexchange":
        return {
          title: "Operator Student Exchange",
          path: "/operator-studentexchange/data-pendaftaran",
          icon: <UserCog className="w-6 h-6" />,
          description: "Manajemen pendaftaran program Student Exchange.",
          color: "bg-violet-100 text-violet-700",
          darkColor: "dark:bg-violet-900/30 dark:text-violet-400",
        };

      default:
        return null;
    }
  };

  if (!isPending && !user) return <Navigate to={"/"} />;

  return (
    <div className="min-h-screen bg-slate-50/50 dark:bg-slate-950 transition-colors duration-300">
      <Navbar />
      <main className="container mx-auto px-4 py-12 max-w-7xl">
        {/* Header Section */}
        <div className="text-center space-y-4 mb-12">
          <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900 dark:text-white">
            Avatar Dashboard
          </h1>
          <p className="text-slate-500 dark:text-slate-400 max-w-2xl mx-auto text-lg">
            Anda memiliki akses multi-role. Silakan pilih modul yang ingin Anda
            akses di bawah ini.
          </p>
        </div>

        {/* Grid Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {user?.jenis_user.map((role: Role, index: number) => {
            const card = getCardContent(role);
            if (!card) return null;

            return (
              <Link key={index} to={card.path} className="group">
                <Card className="h-full border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-sm hover:shadow-md dark:shadow-none dark:hover:shadow-slate-800/50 transition-all duration-300 hover:-translate-y-1 overflow-hidden relative">
                  <CardHeader className="flex flex-row items-center gap-4 pb-2">
                    <div
                      className={`p-3 rounded-xl shrink-0 transition-colors ${card.color} ${card.darkColor}`}
                    >
                      {card.icon}
                    </div>
                    {/* Decorative Blob */}
                    <div className="absolute -right-6 -top-6 w-24 h-24 bg-slate-50 dark:bg-slate-800/50 rounded-full blur-2xl group-hover:bg-slate-100 dark:group-hover:bg-slate-800 transition-colors" />
                  </CardHeader>
                  <CardContent className="space-y-4 pt-2">
                    <div>
                      <CardTitle className="text-lg font-bold text-slate-800 dark:text-slate-100 leading-tight mb-2 group-hover:text-primary dark:group-hover:text-blue-400 transition-colors">
                        {card.title}
                      </CardTitle>
                      <CardDescription className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed line-clamp-2">
                        {card.description}
                      </CardDescription>
                    </div>

                    <div className="flex justify-end pt-2">
                      <Button
                        variant="ghost"
                        size="sm"
                        className="text-primary dark:text-blue-400 hover:text-primary dark:hover:text-blue-300 hover:bg-primary/5 dark:hover:bg-blue-900/20 p-0 h-auto font-medium group/btn"
                      >
                        Akses Modul
                        <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover/btn:translate-x-1" />
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            );
          })}
        </div>
      </main>
    </div>
  );
}
